var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    viewBox: "0 0 35 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.767 22.6802C28.7191 17.3562 33.1263 14.7661 33.3278 14.6456C30.8318 11.0065 26.9632 10.5093 25.6037 10.4697C22.3545 10.1277 19.2028 12.4139 17.5477 12.4139C15.8595 12.4139 13.3107 10.5027 10.5636 10.5589C7.02866 10.6134 3.72166 12.66 1.90792 15.8382C-1.83517 22.3184 0.956455 31.8413 4.54263 37.0793C6.33654 39.6447 8.43274 42.509 11.1765 42.4082C13.8607 42.2975 14.8634 40.6969 18.1027 40.6969C21.3122 40.6969 22.2538 42.4082 25.052 42.3438C27.9328 42.2975 29.7466 39.7669 31.4777 37.1785C33.5508 34.2382 34.3833 31.3425 34.4164 31.1938C34.3486 31.1707 28.8215 29.0613 28.767 22.6802Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4812 7.02395C24.9249 5.21848 25.9127 2.76217 25.6385 0.269531C23.5489 0.362035 20.9357 1.7149 19.4308 3.48073C18.0994 5.03677 16.9101 7.58723 17.2173 9.98572C19.5646 10.1608 21.9747 8.80134 23.4812 7.02395Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleicon);
export default __webpack_public_path__ + "static/media/appleicon.e0ba96634a583a02665d01c271446e6a.svg";
export { ForwardRef as ReactComponent };